"use strict";
/*planCommandMonitorAddModule
策划中心 指挥监测中心  弹出框的样式设计
2017年 07-18  
 */
angular.module("planCommandMonitorShareModule", [])
    .controller('planCommandMonitorShareCtrl', ['$scope', '$modalInstance','$location', 'item', 'confirmBtn', 'trsHttpService', 'modalDialog', "$document",
        function($scope, $modalInstance,$location, item, confirmBtn, trsHttpService, modalDialog, $document) {
            initStatus();

            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.data = {
                    items: item,
                    confirmBtn: confirmBtn || "复制链接和密码"
                };
                $scope.hostValue=$location.host();
                $scope.multiCheck = true;
                $scope.dataList = [];
                $scope.screenNum = "";
                initData();
            };

            function initData() {
                var params = {
                    modalname: "shareUrlAndPwd",
                    method: "share",
                    methodname: "queryDataFromBigScreen",
                    serviceid: "mlf_bigdatascreen",
                    id: $scope.data.items.id,
                    scene_level: $scope.data.items.type
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    data.mapResult.content.beforeUrl = "链接：";
                    data.mapResult.content.beforePwd = "密码：";
                    $scope.dataList.push(data.mapResult.content);
                    if (params.scene_level == 6) {
                        var obj = {
                            url: data.mapResult.content.url_nine,
                            password: data.mapResult.content.password_nine,
                            beforeUrl: "九屏链接：",
                            beforePwd: "九屏密码："
                        };
                        $scope.dataList.push(obj);
                    };

                });
            };
            /**
             * [copyItem description] 复制单条连接和密码
             * @return {[type]} [description]
             */
            $scope.copyItem = function(index) {
                copy(index);
            };
            /**
             * [confirm description] 确定复制全部连接和密码
             * @return {[type]} [description]
             */
            $scope.confirm = function() {
                copy();
            };
            /**
             * [copy description] 复制链接和密码
             * @return {[type]} [description]
             */
            function copy(index) {
                $scope.multiCheck = false;
                setTimeout(function() {
                    window.getSelection().removeAllRanges();
                    if (index == 0 || index == 1) {
                        var newElem = document.querySelector('div.selectedNode' + index);
                    } else {
                        var newElem = document.querySelector('.content.bdoc');
                    };
                    var range = document.createRange();
                    range.selectNode(newElem);
                    window.getSelection().addRange(range);
                    var successful = document.execCommand('copy');
                    window.getSelection().removeAllRanges();
                    $scope.multiCheck = true;
                    //提示
                    if (successful) {
                        modalDialog.alertType("复制成功", "", "success", false, function() {
                            $modalInstance.dismiss();
                        });
                    } else {
                        modalDialog.alertType("浏览器不支持复制", "", "error", false, function() {
                            $modalInstance.dismiss();
                        });
                    };
                }, 50)
            };
            /**
             * [cancel description] 取消
             * @return {[type]} [description]
             */
            $scope.cancel = function() {
                $modalInstance.dismiss();
            };
            /**
             * [resetPwd description] 重置密码
             * @return {[type]} [description]
             */

            $scope.resetPwd = function(index) {
                if ($scope.data.items.type == 6) {
                    $scope.screenNum = 1;
                    if (index == 1) {
                        $scope.screenNum = 0;
                    };
                };
                var params = {
                    modalname: "shareUrlAndPwd",
                    method: "reset",
                    methodname: "queryDataFromBigScreen",
                    serviceid: "mlf_bigdatascreen",
                    id: $scope.data.items.id,
                    scene_level: $scope.data.items.type,
                    is_one_screen: $scope.screenNum
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    $scope.dataList[index].password = data.mapResult.content.password;
                    $scope.screenNum = "";
                });
            };
        }
    ]);